const IntegrationStatusEnum = Object.freeze({
    AWAITING_SPEC_FOR_ENUM: 'AWAITING_SPEC_FOR_ENUM'
});

export default IntegrationStatusEnum;
